// navigation.reducer.js emits one flat list where `title: true` entries act as
// group separators (the CoreUI sidebar format). The rail renders groups, so fold
// the flat list into them. Entries before the first separator form the leading
// group, which has no heading. Groups that end up empty are dropped along with
// their heading (#42358).
export const groupNavigationItems = (items) => {
    if (!items || items.length === 0) {
        return [];
    }

    const groups = [{ label: null, items: [] }];

    items.forEach((item) => {
        if (item.title) {
            groups.push({ label: item.name, items: [] });
            return;
        }
        groups[groups.length - 1].items.push(item);
    });

    return groups.filter((group) => group.items.length > 0);
};

export default groupNavigationItems;
